// extracted by mini-css-extract-plugin
module.exports = {"content":"slug_content__NEFJa","date":"slug_date__XeVYX","categories":"slug_categories__TaxVM"};